import React from 'react';
import './Objective.css'; // Import the CSS file for styling

const Objective = () => {
  return (
    <div className="objective-container">
      <h2 className="objective-title">Our Objectives</h2>
      <ul className="objective-list">
        <li>Eradication of the evil of intoxicating drinks and drugs.</li>
        <li>Bringing about prohibition of the consumption of intoxicating drinks and drugs with the active support and cooperation of the people, social institutions, public bodies, and government.</li>
        <li>Dissemination of scientific knowledge about alcohol, narcotics, and narcotic drugs.</li>
        <li>Helping the victims of alcohol, narcotics, and narcotic drugs in giving up the habit or addiction, or the craving or urge.</li>
        <li>We support and study various aspects of prohibition, scientifically and socially, making research collectively.</li>
        <li>We spread useful knowledge on matters relating to the prohibition of intoxicating drinks and drugs.</li>
        <li>We hold demonstration exhibitions and competitions to promote the cause and ill effects of drinks and drugs.</li>
        <li>We educate the public through lectures, newspaper publications, and distribution of handbills, pamphlets, posters, and other literature.</li>
        <li>We build public opinion against intoxicating drinks and drugs.</li>
      </ul>
    </div>
  );
};

export default Objective;
